import React from 'react';
import { Page, Document, Image, StyleSheet, View, Text } from '@react-pdf/renderer';
import InvoiceTitle from './InvoiceTitle'
import BillTo from './BillTo'
import BillFrom from './BillFrom'
import InvoiceDate from './InvoiceDate'
import InvoiceItemsTable from './InvoiceItemsTable'
import InvoiceDetailsTable from './InvoiceDetailsTable';
import InvoiceThankYouMsg from './InvoiceThankYouMsg'
import InvoiceBankDetailsTable from './InvoiceBankDetailsTable';

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft:60,
        paddingRight:60,
        lineHeight: 1.5,
        flexDirection: 'column',
        display: 'flex',
        flexDirection: 'row'
    }, 
    logo: {
        width: 90,
        height: 74,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    invoice_style: {
        display: 'flex',
        flexDirection: 'column',
        transform: 'rotate(270deg)',
        position: 'absolute',
        top: '220px',
        width: '80px',
        left: '-10px'
    },
    invoice_no: {
        position: 'relative',
        top: '-13px',
        left: '70px',
        fontSize: 15,
        color: '#c00000',
        width: '300px',
    },
    billTo_style: {
        display: 'flex',
        flexDirection: 'row-reverse',
    }
  });
  
  const Invoice = ({invoice}) => {
    // console.log("lohith:Invoice: invoice = ",invoice);
    return(
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.invoice_style}>
                    {/* <InvoiceTitle title='Invoice'/> */}
                    <InvoiceTitle title='Receipt'/>
                    <Text style={styles.invoice_no}>#{invoice.invoice_no}</Text>
                </View>
                <View>
                    <BillFrom invoice={invoice}/>
                    <BillTo invoice={invoice}/>
                    <InvoiceItemsTable invoice={invoice} />
                    <InvoiceDetailsTable invoice={invoice} />
                    <InvoiceThankYouMsg />
                    {/* <InvoiceBankDetailsTable invoice={invoice} /> */}
                </View>
            </Page>
        </Document>
    )
};
  
  export default Invoice